import React, { useMemo, useState, useEffect, useCallback } from "react";
import Customtable from "../helper/Customtable";
import Swal from "sweetalert2";
import { post } from "../helper/api_helper";

const Cfs_status = () => {
  const [cfs_statusList, setCfs_statusList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);

  // ------------------------------
  // Alert Helper
  // ------------------------------
  const showAlert = useCallback((icon, title, text, timer = 2000) => {
    Swal.fire({
      icon,
      title,
      text: text || "Something went wrong.",
      timer,
      showConfirmButton: false,
    });
  }, []);

  // ------------------------------
  // Fetch Data
  // ------------------------------
  const fetchData = useCallback(async () => {
    try {
      const response = await post("/operations/cfs_status/list");
      if (response.status === 200) {
        setCfs_statusList(response.data);
      } else {
        showAlert("error", response.status, response.message);
      }
    } catch (err) {
      showAlert("error", "Unexpected Error", err.message);
    }
  }, [showAlert]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);


  // ------------------------------
  // Table Columns
  // ------------------------------
  const columns = useMemo(
    () => [
      { header: "S.No", label_condition: "s_no", enableColumnFilter: false, enableSorting: false },
      { header: "CFS", accessorKey: "cfs" },
      { header: "Job Ref", accessorKey: "job_no" },
      { header: "Consignee", accessorKey: "consignee" },
      { header: "Liner", accessorKey: "liner" },
      { header: "BL No.", accessorKey: "bl_no" },
      { header: "Ctrs", accessorKey: "ctrs" },
      { header: "Arrived", accessorKey: "arrived" },
      { header: "Dem Upto", accessorKey: "dem_upto" },
      { header: "Storage Date", accessorKey: "storage_date" },
      { header: "Wt (MT)", accessorKey: "weight" },
      { header: "BE No.", accessorKey: "be_no"},
    ],
    []
  );
  // ------------------------------
  // Render
  // ------------------------------
  return (
    <>
      <div className="page-header d-flex justify-content-between align-items-center">
        <div>
          <div className="page-header-title">CFS Arrival Status</div>
          <div className="page-header-sub">Container-wise status per CFS</div>
        </div>
      </div>

      <div className="card basic-data-table mt-3">
        <div className="card-header">
          <h5 className="card-title mb-0">CFS Arrival Status</h5>
        </div>
        <div className="card-body">
          <Customtable
            table_title="CFS Arrival Status"
            columns={columns}
            data={cfs_statusList}
            isGlobalFilter={true}
            isPagination={true}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            isExportButton={true}
          />
        </div>
      </div>
    </>
  );
};

export default Cfs_status;